module.exports = __webpack_public_path__ + "static/img/trial.848e439.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trial.gif
// module id = eiUe
// module chunks = 1